import React, { useEffect, useState } from "react";
import { Popover } from "react-tiny-popover";
import "./chainselect.scss";
import { AiOutlineCaretDown } from "react-icons/ai";
import { changeWeb3AuthChain } from "../../utils/services/web3auth";
import { useSelector } from "react-redux";
import { checkMetamaskCurrentChain } from "../../utils/services/evm";

interface ChainSelectProps {
  theme: string;
  version: string;
}

const ChainSelect: React.FC<ChainSelectProps> = ({ theme, version }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [currentChain, setCurrentChain] = useState<string | null>(null);
  const store = useSelector((store: any) => store);

  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {
      setCurrentChain(store?.currentChain?.currentChain);
    }
    return () => {
      componentMounted = false;
    };
  }, [store?.currentChain]);

  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {
      (async () => {
        let currentChain = await checkMetamaskCurrentChain();
        await handleNetworkSwitch(currentChain ? currentChain : 'polygon');
      })();
    }
    return () => {
      componentMounted = false;
    };
  }, []);

  const handleNetworkSwitch = async (networkName: string | null) => {
    if (networkName) {
      await changeWeb3AuthChain(networkName);
      setIsPopoverOpen(false);
    }
  };

  return (
    <Popover
      isOpen={isPopoverOpen}
      positions={["bottom", "left", "right"]}
      onClickOutside={() => setIsPopoverOpen(false)}
      containerClassName={
        version === "long" ? "longPopoverContainer" : "shortPopoverContainer"
      }
      content={
        <div className="chainsList">
          <div className="chainsList__searchbar"></div>

          <div
            className="chainsList__chainItem"
            onClick={() => handleNetworkSwitch("fvm")}
          >
            <img src="/chain_icons/filecoin.png" alt="" />
            <p>Filecoin - Mainnet</p>
          </div>
          <div
            className="chainsList__chainItem"
            onClick={() => handleNetworkSwitch("polygon")}
          >
            <img src="/chain_icons/polygon.png" alt="" />
            <p>Polygon</p>
          </div>
          <div
            className="chainsList__chainItem"
            onClick={() => handleNetworkSwitch("base")}
          >
            <img src="/chain_icons/base.png" alt="" />
            <p>Base</p>
          </div>
        
        </div>
      }
    >
      <div
        className="ChainBar"
        style={
          version === "long"
            ? { background: "#f8f8f8" }
            : { background: "transparent" }
        }
      >
        {version === "long" && (
          <div className="ChainBar__title">Select Your Chain</div>
        )}

        <div
          className={theme === "dark" ? "darkPopoverBtn" : "popoverBtn"}
          onClick={() => setIsPopoverOpen(!isPopoverOpen)}
        >
          {(currentChain === "polygon" ||
            currentChain === "polygon-testnet") && (
            <>
              {" "}
              <img src="/chain_icons/polygon.png" alt="imgLogo" /> Polygon
            </>
          )}            
          {currentChain === "fvm" && (
            <>
              {" "}
              <img src="/chain_icons/filecoin.png" alt="imgLogo" />
              Filecoin - Mainnet
            </>
          )}
          {currentChain === "base" && (
            <>
              {" "}
              <img src="/chain_icons/base.png" alt="imgLogo" />
              Base
            </>
          )}
         
         
          {currentChain === null && <>Change Network</>}
          &nbsp; <AiOutlineCaretDown />
        </div>
      </div>
    </Popover>
  );
};

export default ChainSelect;